// extracted by mini-css-extract-plugin
export default {"theme-dark":"cEaqeb","themeDark":"cEaqeb","prev-button":"dzrWF3","prevButton":"dzrWF3","next-button":"F2KbBn","nextButton":"F2KbBn"};